let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gSB6X")).then(() => parcelRequire('fMlpz'));